"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const date_utils_1 = require("../../../utils/date.utils");
const EventListItem_1 = __importDefault(require("./EventListItem"));
const react_redux_1 = require("react-redux");
const EventList = ({ events, noEventsText }) => {
    const lang = (0, react_redux_1.useSelector)((state) => {
        var _a;
        return (_a = state.OptiContentCloud) === null || _a === void 0 ? void 0 : _a.currentLanguage;
    });
    if (events.length === 0) {
        return react_1.default.createElement("p", null, noEventsText || 'No events found');
    }
    const getDate = (event, end) => {
        var _a, _b;
        const date = end ? (_a = event.eventEndDateTime) === null || _a === void 0 ? void 0 : _a.value : (_b = event.eventDateTime) === null || _b === void 0 ? void 0 : _b.value;
        if (date) {
            return (0, date_utils_1.getFormatedGeneralDate)(date, lang || 'en', true);
        }
        return '';
    };
    return (react_1.default.createElement("ul", { className: "list-unstyled" }, events.map((event, i) => {
        var _a, _b, _c, _d, _e, _f, _g;
        return (react_1.default.createElement(EventListItem_1.default, { key: ((_a = event.contentLink) === null || _a === void 0 ? void 0 : _a.id) || i, name: ((_b = event.name) === null || _b === void 0 ? void 0 : _b.toString()) || '', link: event.url || '', descriptionWithLink: (_c = event.ingressWithLink) === null || _c === void 0 ? void 0 : _c.value, location: ((_d = event.eventLocation) === null || _d === void 0 ? void 0 : _d.value) || '', date: getDate(event, false), enddate: getDate(event, true), hideLink: (_e = event.hideEventPage) === null || _e === void 0 ? void 0 : _e.value, icon: (_f = event.eventListIcon) === null || _f === void 0 ? void 0 : _f.value, lang: (_g = event.eventLanguage) === null || _g === void 0 ? void 0 : _g.value }));
    })));
};
exports.default = EventList;
